module.exports = __webpack_public_path__ + "static/logo-gmf-aero-asia-06b62bafbcd119edc84f772fa2f3e308.png";